<template>
  <div>
    <!-- Page Header Start -->
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="BookingSelectList"
          :extra-items="[
            {
              text: bookingPreset.name,
              to: 'BookingList',
              params: $route.params.id
            },
            currentStepTitle
          ]"
        />
      </div>
    </div>
    <!-- Page Header End -->

    <!-- Form Start -->
    <div class="email-wrapper wrapper">
      <div class="row bg-white">
        <div class="col-md-2 mail-sidebar pt-3">
          <div class="menu-bar">
            <ul class="menu-items">
              <li
                :class="{
                  active: step == '',
                  'has-checkbox': true,
                  'has-checkbox--checked': bookingPreset.id,
                }"
                @click="goToStep('')"
              >
                <a>時段設定</a>
              </li>
              <li
                :class="{
                  active: step == '#limit-setting',
                  'has-checkbox': true,
                  'has-checkbox--checked': bookingPreset.id,
                }"
                @click="goToStep('#limit-setting')"
              >
                <a>預約次數限制</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-10 main-view">
          <b-overlay :show="showLoading">
            <b-card>
              <!-- 基本資料 section start -->
              <section v-if="step == ''">
                <!-- 欄位部分 Start -->
                <div class="row d-flex mb-4 mb-xl-2">
                  <h4 class="col-12 col-xl-4 mb-3 font-weight-bold">
                    {{ bookingPreset.name }}
                  </h4>
                  <div class="col-12 col-xl-8 mb-3">
                    <div class="row g-2">
                      <div class="col-12 col-xl-3" v-if="this.checkPermission([consts.BOOKING_SETTING_DAY_IMPORT]) && this.presetTimeField.date_condition === 'limited'">
                        <b-button
                          v-b-modal.modal-upload
                          class="w-100"
                          variant="inverse-info"
                        >
                          <span class="mdi mdi-cloud-upload mr-1 me-1"></span>批次匯入日期
                        </b-button>
                      </div>
                      <div class="col-12 col-xl-3" v-if="this.presetTimeField.date_condition === 'limited'">
                        <b-button
                          @click="handleExport"
                          class="w-100"
                          variant="inverse-info"
                        >
                          <span class="mdi mdi-cloud-download mr-1 me-1"></span>匯出日期紀錄
                        </b-button>
                      </div>
                      <div class="col-12 col-xl-6">
                        <AppSingleSelect
                          v-model="branch"
                          :options="branchOptions"
                          @input="formatAndFetchPreset"
                          class="w-100"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-8">
                    <validation-error-alert
                      v-if="validationErrors"
                      :errors="validationErrors"
                    ></validation-error-alert>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="預約時間"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="presetTimeField.format"
                        disabled
                      >
                        <b-form-radio value="datetime">日期＋時間</b-form-radio>
                        <b-form-radio value="date">日期</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="日期格式"
                      v-if="isInclude('date', presetTimeField.format)"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="presetTimeField.date_condition"
                        disabled
                      >
                        <b-form-radio value="unlimited">自行選擇日期</b-form-radio>
                        <b-form-radio value="limited">特定日期</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="日期呈現樣式"
                      v-if="isInclude('date', presetTimeField.format)"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.date_style"
                        disabled
                      >
                        <b-form-radio value="default">預設</b-form-radio>
                        <b-form-radio value="calendar_style">日曆下拉</b-form-radio>
                        <b-form-radio value="select_style">日期下拉</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>



                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="每週行事曆"
                      v-if="presetTimeField.format == 'date'"
                    >
                      <b-form-checkbox
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.reservation_periods_enabled"
                      >啟用
                      </b-form-checkbox>
                    </b-form-group>

                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="時間格式"
                      v-if="isInclude('datetime', presetTimeField.format)"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="presetTimeField.time_condition"
                        disabled
                      >
                        <b-form-radio value="unlimited">自行選擇時間</b-form-radio>
                        <b-form-radio value="limited">連續時間</b-form-radio>
                        <b-form-radio value="specified">特定時間</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="時間呈現樣式"
                      v-if="(presetTimeField.format == 'datetime') && (presetTimeField.time_condition == 'limited' || presetTimeField.time_condition == 'specified')"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.time_style"
                        :disabled="isWizard"
                      >
                        <b-form-radio value="default">預設</b-form-radio>
                        <b-form-radio value="time_select_style" :disabled="true">時間下拉</b-form-radio>
                        <b-form-radio value="select_style" :disabled="presetTimeField.time_condition == 'unlimited'" >自訂下拉</b-form-radio>
                        <b-form-radio value="button_style" :disabled="presetTimeField.time_condition == 'unlimited'" >內嵌時間</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="時段設定"
                      v-if="(presetTimeField.format == 'datetime' && presetTimeField.time_condition == 'specified')"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.daily_time"
                        @change="handleDailyTimeChange"
                      >
                        <b-form-radio value="daily_fixed_time">每日固定時段</b-form-radio>
                        <b-form-radio value="daily_flexible_time">依日期調整時段</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>


                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="日期區段設定"
                      v-if="isInclude('date', presetTimeField.format) && presetTimeField.date_condition == 'limited'"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.date_config_by"
                        @change="changeDateConfigBy"
                      >
                        <b-form-radio value="default">預設</b-form-radio>
                        <b-form-radio value="custom">自訂</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                      v-if="(isInclude('date', presetTimeField.format) && presetTimeField.date_condition == 'limited')"
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                    >
                      <VueDraggable
                          handle=".option-drag-handler"
                          :list="form.business.options"
                          :disabled="form.business.date_config_by == 'default'"
                        >
                          <div v-for="(option, optionIndex) in form.business.options" class="mb-3" :key="'date-opt-' + optionIndex">


                            <div class="d-flex align-items-center">
                              <div class="flex-grow-1 flex-shrink-1 d-flex align-items-center">
                                <i class="fa fa-bars mr-3 option-drag-handler"></i>
                                <!-- <b-form-input
                                  placeholder="請輸入日期"
                                  v-model="form.business.options[optionIndex].text"
                                  @change="syncOptionValue(optionIndex)"
                                  @compositionstart="compositionStart"
                                  @compositionend="compositionEnd(optionIndex)"
                                  @keydown.enter="event => handleKeyDown({event, optionIndex})"
                                  @paste="e => handlePaste(e, optionIndex)"
                                  :ref="`date_${optionIndex}`"
                                  :disabled="form.business.date_config_by == 'default'"
                                >
                                </b-form-input> -->

                                <AppDatePicker
                                  v-model="form.business.options[optionIndex].value"
                                  :disabled="form.business.date_config_by == 'default'"
                                />
                                <b-form-input
                                  v-model="form.business.options[optionIndex].text"
                                  placeholder="請填入顯示文字"
                                  class="ml-2"
                                  style="width: 200px; flex-shrink: 0;"
                                  :disabled="form.business.date_config_by == 'default'"
                                />
                              </div>
                              <div class="flex-shrink-0">
                                <b-button class="ml-2 p-1 d-inline-flex align-items-center" variant="inverse-success" @click="createOption(optionIndex)" :disabled="form.business.date_config_by == 'default'">
                                  <span class="mdi mdi-18px mdi-playlist-plus"></span>
                                  增加
                                </b-button>
                                <b-button class="ml-2 p-1 d-inline-flex align-items-center" variant="inverse-danger" @click="removeOption(optionIndex)" :disabled="isOnlyOneOption() || form.business.date_config_by == 'default'">
                                  <span class="mdi mdi-18px mdi-playlist-remove"></span>
                                  移除
                                </b-button>
                                <b-button class="ml-2 p-1 d-inline-flex align-items-center btn-inverse-info" v-b-modal="'modal-create-date-option'" @click="dateOptionIndex = optionIndex;" :disabled="form.business.date_config_by == 'default'">
                                  <span class="mdi mdi-18px mdi-calendar-plus"></span>
                                  區間
                                </b-button>
                              </div>
                            </div>

                            <div v-if="form.business.daily_time == 'daily_flexible_time'" class="mt-2 pl-4">
                              <b-card class="shadow-none px-3 pt-3 " no-body>
                                <VueDraggable
                                  handle=".option-drag-handler"
                                  :list="form.business.options.time_options"
                                  :disabled="form.business.date_config_by == 'default'"
                                >
                                  <div v-for="(option, timeOptionIndex) in form.business.options[optionIndex].time_options" class="mb-3 d-flex align-items-center" :key="optionIndex + '-daily-time-opt-' + timeOptionIndex">
                                    <div class="flex-grow-1 flex-shrink-1 d-flex align-items-center">
                                      <i class="fa fa-bars mr-3 option-drag-handler"></i>
                                      <AppTimePicker
                                        v-model="form.business.options[optionIndex].time_options[timeOptionIndex].value"
                                        :disabled="form.business.date_config_by == 'default'"
                                      />
                                      <b-form-input
                                        v-model="form.business.options[optionIndex].time_options[timeOptionIndex].text"
                                        placeholder="請填入顯示文字"
                                        :disabled="form.business.date_config_by == 'default'"
                                        style="width: 200px"
                                        class="ml-2"
                                      />
                                    </div>
                                    <div class="flex-shrink-0" v-if="form.business.date_config_by != 'default'">
                                      <b-button class="ml-2 p-1 d-inline-flex align-items-center" variant="inverse-success" @click="createDailyTimeOption(optionIndex, timeOptionIndex)">
                                        <span class="mdi mdi-18px mdi-playlist-plus"></span>
                                        增加
                                      </b-button>
                                      <b-button class="ml-2 p-1 d-inline-flex align-items-center" variant="inverse-danger" @click="removeDailyTimeOption(optionIndex, timeOptionIndex)" :disabled="form.business.options[optionIndex].time_options.length === 1">
                                        <span class="mdi mdi-18px mdi-playlist-remove"></span>
                                        移除
                                      </b-button>
                                    </div>
                                  </div>
                                </VueDraggable>
                              </b-card>
                            </div>


                          </div>
                        </VueDraggable>
                    </b-form-group>



                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="時間區段設定"
                      v-if="(presetTimeField.format == 'datetime' && presetTimeField.time_condition == 'limited')"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.time_config_by"
                        @change="changeTimeConfigBy"
                      >
                        <b-form-radio value="default">預設</b-form-radio>
                        <b-form-radio value="custom">自訂</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="時間區段設定"
                      v-if="(presetTimeField.format == 'datetime' && presetTimeField.time_condition == 'specified')"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.business.time_config_by"
                        @change="changeTimeConfigBy"
                      >
                        <b-form-radio value="default">預設</b-form-radio>
                        <b-form-radio value="custom">自訂</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                      v-if="(presetTimeField.format == 'datetime' && presetTimeField.time_condition == 'specified' && form.business.daily_time == 'daily_fixed_time')"
                    >
                      <div class="ml-3">
                        <VueDraggable
                          handle=".time-option-drag-handler"
                          :list="form.business.time_options"
                          :disabled="form.business.time_config_by == 'default'"
                        >
                          <div v-for="(option, optionIndex) in form.business.time_options" :key="optionIndex" class="mb-3 d-flex align-items-center">
                            <i class="fa fa-bars mr-2 time-option-drag-handler"></i>
                            <AppTimePicker
                              v-model="form.business.time_options[optionIndex].value"
                              style="width: 120px; flex-shrink: 0;"
                              :disabled="form.business.time_config_by == 'default'"
                            />
                            <b-form-input
                              v-model="form.business.time_options[optionIndex].text"
                              placeholder="請填入顯示文字"
                              class="ml-2"
                              style="width: 90px; flex-shrink: 0;"
                              :disabled="form.business.time_config_by == 'default'"
                            />
                            <div class="ml-2 d-flex flex-shrink-0">
                              <b-button variant="inverse-success" @click="createTimeOption(optionIndex)" class="p-1 d-inline-flex align-items-center" :disabled="form.business.time_config_by == 'default'" size="sm">
                                <span class="mdi mdi-18px mdi-playlist-plus"></span>
                                增加
                              </b-button>
                              <b-button variant="inverse-danger" @click="removeTimeOption(optionIndex)" :disabled="form.business.time_options.length === 1 || form.business.time_config_by == 'default'" class="ml-2 p-1 d-inline-flex align-items-center" size="sm">
                                <span class="mdi mdi-18px mdi-playlist-remove"></span>
                                移除
                              </b-button>
                            </div>
                          </div>
                        </VueDraggable>
                      </div>
                    </b-form-group>

                    <b-form-group
                      v-if="presetTimeField.format == 'datetime'"
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                    >
                      <b-form-group
                        v-if="presetTimeField.time_condition != 'specified'"
                        label-cols="4"
                        label-cols-lg="4"
                        label-size="sm"
                      >
                        <template #label>
                          <b-tooltip target="start-time-label" placement="top">
                            開始接預約的時段
                          </b-tooltip>
                          <span id="start-time-label">預約開始時間 <span class="mdi mdi-help-circle-outline"></span> *</span>
                        </template>
                        <AppTimePicker
                          styleType="unlimited"
                          v-model="form.business.start_time"
                          :disabled="form.business.time_config_by == 'default'"
                        />
                      </b-form-group>
                      <b-form-group
                        v-if="presetTimeField.time_condition != 'specified'"
                        label-cols="4"
                        label-cols-lg="4"
                        label-size="sm"
                      >
                        <template #label>
                          <b-tooltip target="end-time-label" placement="top">
                            最後可預約的時段
                          </b-tooltip>
                          <span id="end-time-label">最後預約時間 <span class="mdi mdi-help-circle-outline"></span> *</span>
                        </template>

                        <AppTimePicker
                          styleType="unlimited"
                          v-model="form.business.end_time"
                          :disabled="form.business.time_config_by == 'default'"
                        />
                        <b-form-invalid-feedback
                          :state="!v$.form.business.start_time.beforeEndTime.$invalid"
                        >
                          結束時間必須大於起始時間
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <b-form-group
                        v-if="presetTimeField.time_condition != 'specified'"
                        label-cols="4"
                        label-cols-lg="4"
                        label-size="sm"
                        label="每個時間區段單位 *"
                      >
                        <b-form-input
                          class="mb-2 mr-sm-2 mb-sm-0"
                          type="number"
                          min="0"
                          v-model="form.business.slot_minutes"
                          @input="generateTimeOptions"
                          :disabled="form.business.time_config_by == 'default'"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label-cols="4"
                        label-cols-lg="4"
                        label-size="sm"
                      >
                        <template #label>
                          <b-tooltip target="reset-time-label" placement="top">
                            店家當日休店時段，被預約的服務不會晚於此時段
                          </b-tooltip>
                          <span id="reset-time-label">當日休店時間 <span class="mdi mdi-help-circle-outline"></span> *</span>
                        </template>

                        <AppTimePicker
                          styleType="unlimited"
                          v-model="form.business.closing_time"
                          :disabled="form.business.time_config_by == 'default'"
                        />
                        <b-form-invalid-feedback
                          :state="!v$.form.business.close_time.beforeEndTime.$invalid"
                        >
                          休店時間必須大於等於結束時間
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <b-form-group
                        label-cols="12"
                        label-cols-lg="2"
                        label-size="sm"
                        label="每週行事曆"
                      >
                        <b-form-checkbox
                          class="mb-2 mr-sm-2 mb-sm-0"
                          v-model="form.reservation_periods_enabled"
                        >啟用
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group
                        label-size="sm"
                      >
                        <b-button
                          @click="onTimeFieldChange"
                          variant="success"
                        >
                          重設每週時間
                        </b-button>
                      </b-form-group>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="可預約時間"
                      v-if="form.reservation_periods_enabled"
                    >
                      <b-table-simple responsive >
                        <b-thead>
                          <b-tr>
                            <b-th></b-th>
                            <b-th class="text-center">例行公休日</b-th>
                            <b-th class="text-center">預約開始時間</b-th>
                            <b-th class="text-center">最後預約時間</b-th>
                            <b-th></b-th>
                            <b-th class="text-center">當日休店時間</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <template v-for="(period, dayIndex) in form.reservation_periods">
                            <b-tr :key="`reservation-day-${dayIndex}`" :class="dayIndex % 2 == 0 ? 'custom-table-striped' : ''">
                            <b-td :rowspan="period.business_hours.length" class="align-top">
                              <span>{{ period.display_text }}</span>
                            </b-td>
                            <b-td class="text-center align-top"  :rowspan="period.business_hours.length" >
                              <b-form-checkbox
                                v-model="period.is_official_holiday"
                                @change="updateReservationPeriod(dayIndex, 0, 'is_official_holiday', $event)"
                              ></b-form-checkbox>
                            </b-td>
                            <b-td >
                              <AppTimePicker
                                v-model="period.business_hours[0].start_time"
                                styleType="unlimited"
                                @input="updateReservationPeriod(dayIndex, 0, 'start_time', $event)"
                                :disabled="period.is_official_holiday"
                              />
                              <b-form-invalid-feedback
                                :state="getValidationState(dayIndex, 0, 'start_time', 'beforeEndTime')"
                              >
                                預約開始時間必須小於最後預約時間
                              </b-form-invalid-feedback>
                            </b-td>
                            <b-td >
                              <AppTimePicker
                                v-model="period.business_hours[0].end_time"
                                styleType="unlimited"
                                @input="updateReservationPeriod(dayIndex, 0, 'end_time', $event)"
                                :disabled="period.is_official_holiday"
                              />
                              <b-form-invalid-feedback
                                :state="getValidationState(dayIndex, 0, 'end_time', 'beforeClosingTime')"
                              >
                                最後預約時間必須小於等於當日休店時間
                              </b-form-invalid-feedback>
                            </b-td>
                            <b-td>
                              <b-button variant="link" class="text-primary" size="lg" @click="addBusinessHour(dayIndex)">
                                <i class="mdi mdi-24px mdi-plus-circle-outline"></i>
                              </b-button>
                            </b-td>
                            <b-td :rowspan="period.business_hours.length" class="align-top">
                              <AppTimePicker
                                v-model="period.closing_time"
                                styleType="unlimited"
                                @input="updateReservationPeriod(dayIndex, 0, 'closing_time', $event)"
                                :disabled="period.is_official_holiday"
                              />
                            </b-td>
                            </b-tr>
                            <b-tr v-for="(businessHour, businessHourIndex) in period.business_hours.slice(1)" :key="`reservation-day-${dayIndex}-hour-${businessHourIndex + 1}`" :class="dayIndex % 2 == 0 ? 'custom-table-striped' : ''">
                              <b-td class="border-0 pt-0" >
                                <AppTimePicker
                                  v-model="businessHour.start_time"
                                  styleType="unlimited"
                                  @input="updateReservationPeriod(dayIndex, businessHourIndex+1, 'start_time', $event)"
                                  :disabled="period.is_official_holiday"
                                />
                                <b-form-invalid-feedback
                                  :state="getValidationState(dayIndex, businessHourIndex+1, 'start_time', 'beforeEndTime')"
                                >
                                  預約開始時間必須小於最後預約時間
                                </b-form-invalid-feedback>
                              </b-td>
                              <b-td  class="border-0 pt-0">
                                <AppTimePicker
                                  v-model="businessHour.end_time"
                                  styleType="unlimited"
                                  @input="updateReservationPeriod(dayIndex, businessHourIndex+1, 'end_time', $event)"
                                  :disabled="period.is_official_holiday"
                                />
                                <b-form-invalid-feedback
                                  :state="getValidationState(dayIndex, businessHourIndex+1, 'end_time', 'beforeClosingTime')"
                                >
                                  最後預約時間必須小於等於當日休店時間
                                </b-form-invalid-feedback>
                              </b-td>
                              <b-td  class="border-0 pt-0">
                                <b-button variant="link" class="text-danger" size="lg" @click="removeBusinessHour(dayIndex, businessHourIndex+1)">
                                  <i class="mdi mdi-24px mdi-close-circle-outline"></i>
                                </b-button>
                              </b-td>
                            </b-tr>
                          </template>
                        </b-tbody>
                      </b-table-simple>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="人數限制"
                      v-if="false"
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0"
                        type="text"
                        v-model="form.business.limit_type"
                        @change="generateTimeOptions"
                      >
                        <b-form-radio value="unlimit">不限</b-form-radio>
                        <b-form-radio value="limit_by_slot">依時段限定</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                      v-if="false"
                    >
                      時段限定
                      <input
                        class="mb-2 mr-sm-2 mb-sm-0 w-4"
                        type="text"
                        v-model="form.business.slot_people"
                        @input="generateTimeOptions"
                      /> 人
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="預覽"
                      v-if="false && presetLimitType == 'time' && isEnabledOccupySetting && presetTimeField.format == 'datetime' &&  occupySetting.is_check_branch"
                    >
                      <div v-for="(timeOption, index) in form.time_options" v-bind:key="index">
                        <b-form-group
                          label-cols="6"
                          label-cols-lg="6"
                          label-size="sm"
                          :label="timeOption.title"
                        >
                          <b-form-input v-model="timeOption.value" :disabled="form.business.limit_type == 'unlimit'"></b-form-input>
                        </b-form-group>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <!-- 欄位部分 End -->
                <!-- 表單底部 Start -->
                <div class="d-flex justify-content-center" style="margin-top: 80px;">
                  <b-button
                    :disabled="disabledButton"
                    class="mr-3"
                    @click="cancel"
                    variant="outline-danger"
                  >
                    返回
                  </b-button>
                  <b-button
                    :disabled="
                      disabledButton ||
                      v$.form.business.start_time.beforeEndTime.$invalid ||
                      v$.form.business.close_time.beforeEndTime.$invalid ||
                      hasReservationValidationErrors
                    "
                    @click="submit('time-setting')"
                    variant="success"
                  >
                    儲存
                  </b-button>
                </div>
                <!-- 表單底部 End -->
              </section>
              <section v-if="step == '#limit-setting'">
                <div class="row d-flex mb-4 mb-xl-2">
                  <h4 class="col-12 col-xl-4 mb-3 font-weight-bold">
                    {{ bookingPreset.name }}
                  </h4>
                  <div class="col-12 col-xl-8 mb-3">
                    <AppSingleSelect
                      v-model="branch"
                      :options="branchOptions"
                      @input="formatAndFetchPreset"
                      class="w-100"
                    />
                  </div>
                  <div class="col-12 col-xl-8">
                    <validation-error-alert
                      v-if="validationErrors"
                      :errors="validationErrors"
                    ></validation-error-alert>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                    >
                      <b-form-checkbox
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="form.occupy_config.enable"
                        disabled
                      >
                        預約次數限制
                        <span
                          v-if="occupyCustomDisabledTip"
                          id="occupy-limit-setting-tip"
                          class="ml-1 text-muted occupy-limit-tip-icon"
                        >
                          <span class="mdi mdi-help-circle-outline"></span>
                        </span>
                      </b-form-checkbox>
                      <b-tooltip
                        v-if="occupyCustomDisabledTip"
                        target="occupy-limit-setting-tip"
                        placement="top"
                      >
                        {{ occupyCustomDisabledTip }}
                      </b-tooltip>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label=""
                    >
                      <b-form-radio-group
                        class="mb-2 mr-sm-2 mb-sm-0 limit-setting-radio-group"
                        v-model="occupyTypeModel"
                        :disabled="!form.occupy_config.enable"
                        name="occupy-config-type"
                      >
                        <b-form-radio :key="'occupy-type-default'" value="default">預設</b-form-radio>
                        <b-form-radio
                          :key="'occupy-type-custom'"
                          value="custom"
                          :disabled="!isOccupyCustomAllowed"
                        >
                          自訂
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="次數上限"
                    >
                      <div class="d-flex align-items-center">
                        <span class="mr-2">依時段設定 時段限制</span>
                        <b-form-input
                          type="number"
                          min="0"
                          v-model="form.occupy_config.slot_people"
                          style="width: 100px;"
                          :disabled="!canEditOccupyConfig"
                        />
                        <span class="ml-2">人</span>
                      </div>
                    </b-form-group>
                    <b-form-group
                      label-cols="12"
                      label-cols-lg="2"
                      label-size="sm"
                      label="前台用戶顯示設定"
                    >
                      <b-form-input
                        v-model="form.occupy_config.full_alert_text"
                        placeholder="該時段的預約數量已達上限"
                        :disabled="!canEditOccupyConfig"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="d-flex justify-content-center" style="margin-top: 80px;">
                  <b-button
                    :disabled="disabledButton"
                    class="mr-3"
                    @click="cancel"
                    variant="outline-danger"
                  >
                    返回
                  </b-button>
                  <b-button
                    :disabled="disabledButton ||
                     !isOccupyCustomAllowed ||
                     !form.occupy_config.enable
                    "
                    @click="submit('limit-setting')"
                    variant="success"
                  >
                    儲存
                  </b-button>
                </div>
              </section>
              <!-- 基本資料 section end -->
            </b-card>
          </b-overlay>
        </div>
      </div>
    </div>
    <!-- Form End -->
    <b-modal
      id="modal-create-date-option"
      title="設定時間範圍"
      centered
      @hidden=";"
      @ok="createOptionByCalendar"
    >
      <form ref="form" @submit.stop.prevent=";">
        <AppDatePicker v-model="optionStartDate"/>
        ~
        <AppDatePicker v-model="optionEndDate"/>
      </form>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="danger" @click="cancel()">
          取消
        </b-button>
        <b-button size="sm" variant="success" @click="ok()">
          新增
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-upload" title="上傳" hide-footer>
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳 Excel 檔案</label>
          <div class="my-3">已選擇檔案 : {{ file ? file.name : "" }}</div>
          <b-form-file class="mb-3" plain v-model="file" @change="handleUploadFile" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
      </b-overlay>
      <template>
        <div class="w-100 d-flex justify-content-between align-items-center">
          <!-- 靠左 -->
          <b-button
            size="sm"
            variant="outline-primary"
            href="/excel/branch_day_import.xlsx"
            target="_blank"
          >
            <i class="fa fa-file-text"></i> 下載範例檔案
          </b-button>

          <!-- 靠右 -->
          <div>
            <b-button
              variant="outline-danger"
              size="sm"
              class="mr-2"
              @click="resetFile"
            >
              取消
            </b-button>
            <b-button
              size="sm"
              variant="outline-primary"
              @click="upload"
            >
              確認
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { zh } from "vuejs-datepicker/dist/locale";
import useVuelidate from "@vuelidate/core";
import bookingApi from "@/apis/booking";
import mergeDefaultAndDataModel from "@/utils/mergeDefaultAndDataModel";
import deepGet from "lodash/get";
import moment from "moment";
import { mapGetters } from "vuex";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import AppTimePicker from '@/components/AppTimePicker.vue';
import AppDatePicker from '@/components/AppDatePicker.vue';
import VueDraggable from "vuedraggable";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    AppTimePicker,
    VueDraggable,
    AppSingleSelect,
    AppDatePicker,
    BreadCrumb
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    const reservationValidations = {}

    // 為每個週期添加驗證規則
    if (this.form.reservation_periods) {
      Object.keys(this.form.reservation_periods).forEach(dayIndex => {
        const period = this.form.reservation_periods[dayIndex]
        if (!period || !period.business_hours) return

        reservationValidations[dayIndex] = {
          business_hours: {}
        }

        // 為每個 business_hour 添加驗證規則
        period.business_hours.forEach((businessHour, businessHourIndex) => {
          reservationValidations[dayIndex].business_hours[businessHourIndex] = {
            start_time: {
              beforeEndTime: () => {
                if (period.is_official_holiday || !businessHour) return true
                return businessHour.start_time && businessHour.end_time &&
                  moment(businessHour.start_time, 'HH:mm')
                    .isBefore(moment(businessHour.end_time, 'HH:mm'))
              },
            },
            end_time: {
              beforeClosingTime: () => {
                if (period.is_official_holiday || !businessHour) return true
                return businessHour.end_time && period.closing_time &&
                  !moment(businessHour.end_time, 'HH:mm')
                    .isAfter(moment(period.closing_time, 'HH:mm'))
              }
            }
          }
        })
      })
    }

    return {
      form: {
        business: {
          start_time: {
            beforeEndTime: () => {
              return this.form.business.start_time && this.form.business.end_time &&
                moment(this.form.business.start_time, 'HH:mm')
                  .isBefore(moment(this.form.business.end_time, 'HH:mm'))
            },
          },
          close_time: {
            beforeEndTime: () => {
              return this.form.business.closing_time && this.form.business.end_time &&
                !moment(this.form.business.closing_time, 'HH:mm')
                  .isBefore(moment(this.form.business.end_time, 'HH:mm'))
            }
          }
        },
        reservation_periods: reservationValidations
      },
    };
  },
  computed: {
    ...mapGetters("route", ["routeQuery"]),
    ...mapGetters("general", ["myBranches"]),
    occupySetting() {
      return this.bookingPreset?.config?.occupy_config
    },
    isOccupyCustomAllowed() {
      const occupyConfig = this.bookingPreset?.config?.occupy_config || {}
      return occupyConfig.enable === true
        && occupyConfig.is_check_branch === true
        && occupyConfig.is_check_staff === false
        && occupyConfig.is_check_service === false
        && occupyConfig.is_check_collection === false
    },
    occupyCustomDisabledTip() {
      const occupyConfig = this.bookingPreset?.config?.occupy_config || {}
      if (occupyConfig.enable !== true) {
        return "預約設定檔未啟用預約次數限制"
      }
      if (!this.isOccupyCustomAllowed) {
        return "預約次數限制只允許分店次數限制，此預約設定檔有其他額外的限制，因此無法啟用分店限制"
      }
      return ""
    },
    isEnabledOccupySetting() {
      return this.bookingPreset?.config?.occupy_config?.enable
    },
    presetLimitType() {
      return this.bookingPreset?.config?.occupy_config?.limit_type
    },
    currentStepTitle() {
      return this.step === '#limit-setting' ? '預約次數限制' : '時段設定'
    },
    occupyTypeModel: {
      get() {
        return this.form.occupy_config.type === "custom" ? "custom" : "default"
      },
      set(value) {
        this.form.occupy_config.type = value === "custom" ? "custom" : "default"
      },
    },
    canEditOccupyConfig() {
      return this.form.occupy_config.enable && this.form.occupy_config.type === "custom"
    },
    hasReservationValidationErrors() {
      try {
        if (!this.v$.form.reservation_periods) return false

        return Object.keys(this.v$.form.reservation_periods).some(dayIndex => {
          const dayValidation = this.v$.form.reservation_periods[dayIndex]
          if (!dayValidation || !dayValidation.business_hours) return false

          // 檢查每個 business_hour 的驗證錯誤
          return Object.keys(dayValidation.business_hours).some(businessHourIndex => {
            const businessHourValidation = dayValidation.business_hours[businessHourIndex]
            if (!businessHourValidation) return false

            const startTimeInvalid = businessHourValidation.start_time &&
              businessHourValidation.start_time.beforeEndTime &&
              businessHourValidation.start_time.beforeEndTime.$invalid
            const endTimeInvalid = businessHourValidation.end_time &&
              businessHourValidation.end_time.beforeClosingTime &&
              businessHourValidation.end_time.beforeClosingTime.$invalid

            return startTimeInvalid || endTimeInvalid
          })
        })
      } catch (error) {
        return false
      }
    },
    branchOptions() {
      let options = this.myBranches
        .map(branch => {
          let branchName = `${branch.branch_code} ${branch.name}`
          return {
            value: branch.id,
            text: branchName
          }
        })
      return options
    },
  },
  data() {
    return {
      consts,
      zh,
      slot_people: 0,
      showLoading: false,
      validationErrors: null,
      step: "",
      branchId: null,
      branch: {},
      dateOptionIndex: 0,
      optionStartDate: null,
      optionEndDate: null,
      bookingPreset: {
        name: "",
        config:{
          booking_mapping: {
            bookings: {
              start_at: null,
              start_at_by_branch: null
            }
          },
          fields:[],
          occupy_config: {
            enable: false,
            limit_type: null,
            is_check_branch: false
          }
        },
        branch_config:[]
      },
      isWizard: false,
      isTyping: false,
      form: {
        business: {
          start_time: "00:00",
          end_time: "23:59",
          slot_minutes: 30,
          time_style: "select_style",
          daily_time: "daily_fixed_time",
          limit_type: "unlimit",
          slot_people: 0,
          time_config_by: "default",
          date_config_by: "default",
          options: [],
          closing_time: "23:59",
        },
        reservation_periods: {},
        time_options: [],
        reservation_periods_enabled: false,
        occupy_config: {
          enable: false,
          type: "default",
          slot_people: "",
          full_alert_text: "",
        }
      },
      option_text: '',
      presetTimeField: {},
      branchTimeField: {},
      hasBranchField: false,
      permissionChecker: new PermissionChecker(),
      disabledButton: false,
      showLoadingUpload: false,
      file: null
    };
  },
  async mounted() {
    this.bookingPreset.id = this.$route.params.id;
    this.branchId = this.$route.params.branch
    // 確保有選擇分店，如果沒有則選擇第一個分店
    if (!this.branchId && this.branchOptions.length > 0) {
      this.branchId = this.branchOptions[0].value
      // 更新網址
      this.$router.replace({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          branch: this.branchId
        },
        query: this.$route.query
      })
    }
    this.branch = this.branchOptions.find(branch => branch.value == this.branchId)
    await this.fetchBookingPreset();
    this.setReservationPeriods();
    this.navigateToStepFromCurrentRoute();
  },
  watch: {
    "form.business.limit_type": (value) => {
      if (value == 'unlimit') {
        this.form.business.slot_people = 0
      }
    },
    "form.occupy_config.type"(value) {
      if (value === "custom" && !this.isOccupyCustomAllowed) {
        this.form.occupy_config.type = "default"
        return
      }
      if (value === "default") {
        this.resetOccupyConfigToPreset()
      }
    },
  },
  methods: {
    deepGet,
    mergeDefaultAndDataModel,
    createOptionByCalendar() {
      const startDate = new Date(this.optionStartDate);
      const endDate = this.optionEndDate;
      for (let date = new Date(endDate); date >= startDate; date.setDate(date.getDate() - 1)) {
        const dateString = date.toISOString().split('T')[0];
        const nextOptionIndex = this.dateOptionIndex + 1

        this.form.business.options.splice(nextOptionIndex, 0, {
          text: '',
          value: dateString,
        });

        // this.$nextTick(() => {
        //   this.$refs[`date_${nextOptionIndex}`][0].select();
        // });
      }

      this.startDate = null;
      this.endDate = null;
    },
    handleKeyDown({optionIndex}) {
      if(this.isTyping) return;
      this.createOption(optionIndex)
      this.$nextTick(() => {
        this.$refs[`date_${optionIndex + 1}`][0].select();
      });
    },
    compositionStart() {
      this.isTyping = true;
    },
    compositionEnd(){
      this.isTyping = false
    },
    handlePaste(event, optionIndex){
      const pasteData = event.clipboardData;
      const pastedText = pasteData.getData('text');

      if (pastedText.includes('\n')) {
        const newOptions = pastedText.split('\n').map((text) => {
          const t = text.trim()
          return {
            text: '',
            value: t,
          };
        });
        this.form.business.options.splice(optionIndex + 1, 0, ...newOptions);
        this.form.business.options.splice(optionIndex, 1);

        // 由於此元件採用 rerendering 做 forceUpdate，使用 nextTick 無法完全確保元素已被渲染
        setTimeout(() => {
          this.$refs[`date_${optionIndex + newOptions.length - 1}`][0].select();
        }, 0);

      } else {
        this.form.business.options[optionIndex].value = pastedText;
      }
    },
    removeOption(optionIndex) {
      if(this.isOnlyOneOption()) return;
      this.form.business.options.splice(optionIndex, 1);
    },
    createOption(optionIndex) {
      const clickedSubjectValue = this.form.business.options[optionIndex].value;
      const nextOptionIndex = optionIndex + 1
      const isDailyFlexibleTime = this.form.business.daily_time === 'daily_flexible_time'

      this.form.business.options.splice(nextOptionIndex, 0, {
        text: '',
        value: clickedSubjectValue,
        ...(isDailyFlexibleTime ? { time_options: [{ text: '', value: '' }] } : {}),
      });

      // this.$nextTick(() => {
      //   this.$refs[`date_${nextOptionIndex}`][0].select();
      // });
    },
    isOnlyOneOption() {
      return this.form.business.options.length === 1;
    },
     presentValidationErrors(validationKey) {
      return deepGet(this.v$, validationKey + ".$errors", [])
        .map((error) => error.$message)
        .join(", ");
    },
    cancel() {
      this.$router.push({ name: "BookingSelectList", query: this.routeQuery });
    },
    goToStep(step) {
      if (!this.bookingPreset.id) {
        return;
      }

      if (this.step == step) {
        return;
      }

      this.step = step;
      if (location.hash !== this.step) {
        // NOTE: 這裡不使用 $router.replace，以避免 page rerender 導致 mounted 或其他 lifecycle hook 的內的 API 重複執行
        const newLocation = new URL(location.href);
        newLocation.hash = this.step;
        window.history.replaceState("", "", newLocation.href);
      }
    },
    navigateToStepFromCurrentRoute() {
      const anchor = this.$route.hash;
      if (anchor) {
        this.goToStep(anchor);
      }
    },
    async submit(section = 'time-setting') {
      // const result = await this.v$.$validate();
      // if (!result) return false;
      try {
        this.showLoading = true;

        let params = {}
        if (section === 'limit-setting') {
          params = {
            config: {
              occupy_config: {
                type: this.form.occupy_config.type === "custom" ? 1 : 0,
                slot_people: this.form.occupy_config.slot_people,
                full_alert_text: this.form.occupy_config.full_alert_text,
              },
            }
          }
        } else {
          params = {
            config: {
              fields: [this.form.business],
              reservation_periods_enabled: this.form.reservation_periods_enabled
            }
          }
        }

        await bookingApi.setupBookingPresetBranch(
          this.bookingPreset.id,
          this.branchId,
          params
        );
        await this.fetchBookingPreset();
        this.$swal("儲存成功", "", "success");

        return true;
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "儲存失敗", "error");
        return false;
      } finally {
        this.showLoading = false;
      }
    },
    async fetchBookingPreset() {
      if (!this.bookingPreset.id) {
        this.$swal("錯誤", "無法取得讀取 ID", "error");
        return;
      }

      try {
        this.showLoading = true;
        let response = await bookingApi.getBookingPreset(this.bookingPreset.id, {
          branch_id: this.branchId
        });

        this.bookingPreset.name = response.data.data.name;
        this.bookingPreset.branch_config = [];

        this.isWizard = response.data.data.type === "wizard";
        this.$set(
          this,
          "bookingPreset",
          this.mergeDefaultAndDataModel(this.bookingPreset, response.data.data)
        );

        if (!this.bookingPreset?.config?.booking_mapping?.bookings?.start_at) {
          this.$swal("錯誤", "此預約設定檔案尚未設定開始時間指派", "error");
          this.disabledButton = true
          return
        }

        if (!this.bookingPreset?.config?.booking_mapping?.bookings?.start_at_by_branch) {
          this.$swal("錯誤", "預約開始時間必須設定分店關聯欄位", "error");
          this.disabledButton = true
          return
        }

        const field = this.deepGet(this.bookingPreset.config, 'fields', [])?.find((field) => field?._id == this.bookingPreset.config.booking_mapping.bookings.start_at);
        this.presetTimeField = field
        const timeField = this.deepGet(this.bookingPreset.branch_config, 'fields', [field])?.find((field) => field?._id == this.bookingPreset.config.booking_mapping.bookings.start_at);
        this.hasBranchField = !!this.deepGet(this.bookingPreset.branch_config, 'fields', [])?.find((field) => field?._id == this.bookingPreset.config.booking_mapping.bookings.start_at);
        this.branchTimeField = timeField
        if (timeField) {
          this.form.business = timeField
          this.formatBusiness()
          this.generateTimeOptions();
        }

        if (typeof response.data.data.branch_config.reservation_periods_enabled != "undefined") {
          this.form.reservation_periods_enabled = response.data.data.branch_config.reservation_periods_enabled;
        } else {
          this.form.reservation_periods_enabled = false;
        }

        const presetOccupyConfig = this.deepGet(this.bookingPreset, 'config.occupy_config', {}) || {}
        const branchOccupyConfig = this.deepGet(this.bookingPreset, 'branch_config.occupy_config', {}) || {}
        const isOccupyEnabled = !!presetOccupyConfig.enable
        const branchType = Number(branchOccupyConfig.type)
        // 分店曾儲存「自訂」時要一直顯示自訂（radio 仍可因 enable=false 而停用，但選項要對）
        const occupyType = branchType === 1 && this.isOccupyCustomAllowed ? "custom" : "default"
        const presetSlotPeople = presetOccupyConfig.slot_people ?? ""
        const presetFullAlertText = presetOccupyConfig.full_alert_text ?? ""

        this.form.occupy_config.enable = isOccupyEnabled
        this.form.occupy_config.type = occupyType
        this.form.occupy_config.slot_people = occupyType === "custom"
          ? (branchOccupyConfig.slot_people ?? presetSlotPeople)
          : presetSlotPeople
        this.form.occupy_config.full_alert_text = occupyType === "custom"
          ? (branchOccupyConfig.full_alert_text ?? presetFullAlertText)
          : presetFullAlertText
        /* else if (this.presetTimeField.format == 'datetime') {
          this.form.reservation_periods_enabled = true;
        } */

        this.$forceUpdate()
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取資料錯誤", "error");
        // this.cancel();
      } finally {
        this.showLoading = false;
      }
    },
    setReservationPeriods() {
      const reservationPeriods = this.deepGet(this.bookingPreset.branch_config, 'reservation_periods', null);
      if (reservationPeriods) {
        this.form.reservation_periods = reservationPeriods;
      } else {
        this.form.reservation_periods = {};
      }
      this.initializeReservationPeriods();
    },
    resetOccupyConfigToPreset() {
      const presetOccupyConfig = this.deepGet(this.bookingPreset, 'config.occupy_config', {}) || {}
      this.form.occupy_config.slot_people = presetOccupyConfig.slot_people ?? ""
      this.form.occupy_config.full_alert_text = presetOccupyConfig.full_alert_text ?? ""
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
    changeTimeConfigBy() {
      const currentTimeStyle = this.form.business.time_style;
      const currentDateStyle = this.form.business.date_style;
      const currentDateConfigBy = this.form.business.date_config_by;
      const currentDailyTime = this.form.business.daily_time;

      if (this.form.business.time_config_by == 'default') {
        this.form.business = this.presetTimeField
        this.form.business.time_config_by = 'default'
      } else {
        if (this.branchTimeField) {
          this.form.business = this.branchTimeField
        }
        this.form.business.time_config_by = 'custom'
      }

      this.form.business.time_style = currentTimeStyle;
      this.form.business.date_style = currentDateStyle;
      this.form.business.date_config_by = currentDateConfigBy;
      this.$set(this.form.business, 'daily_time', currentDailyTime ?? 'daily_fixed_time')

      this.formatBusiness()
      this.$forceUpdate()
    },
    changeDateConfigBy() {
      const currentTimeStyle = this.form.business.time_style;
      const currentDateStyle = this.form.business.date_style;
      const currentTimeConfigBy = this.form.business.time_config_by;
      const currentDailyTime = this.form.business.daily_time;

      if (this.form.business.date_config_by == 'default') {
        this.form.business = this.presetTimeField
        this.form.business.date_config_by = 'default'
      } else {
        if (this.branchTimeField) {
          this.form.business = this.branchTimeField
        }
        this.form.business.date_config_by = 'custom'
      }

      this.form.business.time_style = currentTimeStyle;
      this.form.business.date_style = currentDateStyle;
      this.form.business.time_config_by = currentTimeConfigBy;
      this.$set(this.form.business, 'daily_time', currentDailyTime ?? 'daily_fixed_time')

      this.formatBusiness()
      this.$forceUpdate()
    },
    formatBusiness() {
      this.form.business.slot_minutes = this.form.business.slot_minutes ?? 30
      this.form.business.time_style = this.hasBranchField ? this.form.business.time_style : "default"
      this.form.business.date_style = this.hasBranchField ? this.form.business.date_style : "default"
      this.form.business.limit_type = this.hasBranchField ? this.form.business.limit_type : "unlimit"
      this.form.business.slot_people = this.form.business.slot_people ?? 0
      this.form.business.time_config_by = this.form.business.time_config_by ?? "default"
      this.form.business.date_config_by = this.form.business.date_config_by ?? "default"
      this.$set(this.form.business, 'daily_time', this.form.business.daily_time ?? "daily_fixed_time")
      this.form.business.options = (this.form.business.options ?? [{ text: '', value: '' }]).map((o) => ({
        ...o,
        ...(this.form.business.daily_time === 'daily_flexible_time'
          ? { time_options: o.time_options ?? [{ text: '', value: '' }] }
          : {}),
        value: o.value != null && o.value !== '' ? o.value : o.text,
      }))
      this.form.business.time_options = this.form.business.time_options ?? [{text: '', value: ''}]
      this.form.business.start_time = this.form.business.start_time ?? "00:00"
      this.form.business.end_time = this.form.business.end_time ?? "23:59"
      this.form.business.closing_time = this.form.business.closing_time ?? "23:59"
      this.$forceUpdate()
    },
    isInclude(word, value) {
      if (value) {
        return value.includes(word)
      }
      return false
    },
    async formatAndFetchPreset() {
      this.branchId = this.branch.value

      // 更新網址參數
      this.$router.replace({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          branch: this.branchId
        },
        query: this.$route.query
      })

      await this.fetchBookingPreset()
      this.setReservationPeriods()
    },
    generateTimeOptions() {
        let options = [];
        const slotMinutes = Number(this.form.business.slot_minutes);
        const startTime = this.form.business.start_time;
        const endTime = this.form.business.end_time;

        if (!startTime || !endTime) {
          return [];
        }
        if (slotMinutes < 1) {
          return;
        }
        // 將時間轉換為分鐘
      const timeToMinutes = (time) => {
        if (!time) {
          return 0;
        }
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };

      // 將分鐘轉回時間格式 "HH:MM"
      const minutesToTime = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
      };
      const startMinutes = timeToMinutes(startTime);
      const endMinutes = timeToMinutes(endTime);

      // 計算實際的最後服務時間
      const lastServeMinutes = timeToMinutes(endTime);
      const adjustedLastServeMinutes = lastServeMinutes - Number(0);

      // 確保不會超過 24:00
      const actualEndMinutes = Math.min(endMinutes, adjustedLastServeMinutes);

      let currentMinutes = startMinutes;

      while (currentMinutes <= actualEndMinutes) {
        options.push({
          title: minutesToTime(currentMinutes),
          value: this.form.business.slot_people
        });
        currentMinutes = Number(currentMinutes) + slotMinutes;
        // 防止超過一天的範圍（1440 分鐘）
        if (currentMinutes >= 1440) {
          break;
        }
      }
        /* eslint-enable no-constant-condition */
        this.form.time_options = options;
      },
    createTimeOption(optionIndex) {
      if (!this.form.business.time_options) {
        this.$set(this.form.business, 'time_options', [])
      }
      this.form.business.time_options.splice(optionIndex + 1, 0, {
        text: '',
        value: '',
      })
    },
    removeTimeOption(optionIndex) {
      if (this.form.business.time_options.length === 1) return
      this.form.business.time_options.splice(optionIndex, 1)
    },
    handleDailyTimeChange(dailyTime) {
      if (dailyTime !== 'daily_flexible_time') {
        return
      }
      this.form.business.options.forEach((option, index) => {
        if (!option.time_options || option.time_options.length === 0) {
          this.$set(this.form.business.options[index], 'time_options', [{ text: '', value: '' }])
        }
      })
    },

    createDailyTimeOption(optionIndex, timeOptionIndex) {
      if (!this.form.business.options[optionIndex].time_options) {
        this.$set(this.form.business.options[optionIndex], 'time_options', [])
      }
      this.form.business.options[optionIndex].time_options.splice(timeOptionIndex + 1, 0, {
        text: '',
        value: '',
      })
    },
    removeDailyTimeOption(optionIndex, timeOptionIndex) {
      if (this.form.business.options[optionIndex].time_options.length === 1) return
      this.form.business.options[optionIndex].time_options.splice(timeOptionIndex, 1)
    },

    initializeReservationPeriods() {
      let startTime = this.presetTimeField.format === 'datetime' ? this.presetTimeField.start_time : "00:00";
      let endTime = this.presetTimeField.format === 'datetime' ? this.presetTimeField.end_time : "23:59";
      let closingTime = (this.presetTimeField.format === "datetime" && this.presetTimeField.closing_time) || "23:59";
      if (!this.form.reservation_periods || Object.keys(this.form.reservation_periods).length === 0) {
        this.form.reservation_periods = {
          "1": {
            "display_text": "星期一",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "2": {
            "display_text": "星期二",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "3": {
            "display_text": "星期三",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "4": {
            "display_text": "星期四",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "5": {
            "display_text": "星期五",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "6": {
            "display_text": "星期六",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          },
          "7": {
            "display_text": "星期日",
            "closing_time": closingTime,
            "is_official_holiday": false,
            "business_hours": [
              {
                "start_time": startTime,
                "end_time": endTime
              }
            ]
          }
        }
      }

      // 確保每個週期都有 business_hours 陣列
      Object.keys(this.form.reservation_periods).forEach(dayIndex => {
        if (!this.form.reservation_periods[dayIndex].business_hours) {
          this.form.reservation_periods[dayIndex].business_hours = [
            {
              start_time: this.form.business.start_time,
              end_time: this.form.business.end_time
            }
          ];
        }
      });
    },
    updateReservationPeriod(dayIndex,businessHourIndex, field, value) {
      if (this.form.reservation_periods[dayIndex]) {
        if (field === 'start_time' || field === 'end_time') {
          this.form.reservation_periods[dayIndex].business_hours[businessHourIndex][field] = value
        } else {
          this.form.reservation_periods[dayIndex][field] = value
        }
      }
    },
    addBusinessHour(dayIndex) {
      this.form.reservation_periods[dayIndex].business_hours.push({
        start_time: this.form.reservation_periods[dayIndex].business_hours[this.form.reservation_periods[dayIndex].business_hours.length-1].start_time,
        end_time:  this.form.reservation_periods[dayIndex].business_hours[this.form.reservation_periods[dayIndex].business_hours.length-1].end_time
      })
    },
    removeBusinessHour(dayIndex, businessHourIndex) {
      this.form.reservation_periods[dayIndex].business_hours.splice(businessHourIndex, 1)
    },
    onTimeFieldChange() {
      this.generateTimeOptions()

      // 同時設定所有週期的時間
      Object.keys(this.form.reservation_periods).forEach(dayIndex => {
        if (this.form.reservation_periods[dayIndex]) {
          if (this.presetTimeField.time_condition === 'specified') {
            // 特定時間模式：使用 time_options 的第一個和最後一個值作為「預約開始時間」和「預約結束時間」
            const firstTimeOption = this.form.business.time_options[0].value
            const lastIndex = this.form.business.time_options.length - 1
            const lastTimeOption = this.form.business.time_options[lastIndex].value

            if (this.form.reservation_periods[dayIndex].business_hours && this.form.reservation_periods[dayIndex].business_hours[0]) {
              this.form.reservation_periods[dayIndex].business_hours[0].start_time = firstTimeOption
              this.form.reservation_periods[dayIndex].business_hours[0].end_time = lastTimeOption
              this.form.reservation_periods[dayIndex].business_hours = this.form.reservation_periods[dayIndex].business_hours.slice(0, 1)
            }
          } else {
            // 其他模式：使用「預約開始時間」和「預約結束時間」欄位
            if (this.form.reservation_periods[dayIndex].business_hours && this.form.reservation_periods[dayIndex].business_hours[0]) {
              this.form.reservation_periods[dayIndex].business_hours[0].start_time = this.form.business.start_time
              this.form.reservation_periods[dayIndex].business_hours[0].end_time = this.form.business.end_time
              this.form.reservation_periods[dayIndex].business_hours = this.form.reservation_periods[dayIndex].business_hours.slice(0, 1)
            }
          }
          // 當日休店時間
          this.form.reservation_periods[dayIndex].closing_time = this.form.business.closing_time
        }
      })
    },
    getValidationState(dayIndex, businessHourIndex, field, rule) {
      try {
        const validation = this.v$.form.reservation_periods[dayIndex]?.business_hours[businessHourIndex]?.[field]?.[rule]
        return validation ? !validation.$invalid : true
      } catch (error) {
        return true
      }
    },
    resetFile() {
      this.file = null;
      this.$bvModal.hide("modal-upload");
    },
    handleUploadFile() {
      const data = new FormData();

      data.append("file", new Blob(["test payload"], { type: "text/csv" }));
    },
    async upload() {
      this.showLoadingUpload = true;
      try {
        const fd = new FormData();
        fd.append("file", this.file);

        const { data } = await bookingApi.importBookingPresetDate(this.bookingPreset.id, fd);

        if (data.success) {
          this.$swal.fire({
            title: "上傳成功",
            type: "success",
          });
        } else {
          let errorList = data.failed;

          let errorMessages = errorList
            .map(item => `第 ${item.row} 列：${item.reason}`)
            .join("<br>");

          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
            html: errorMessages,
          });
        }

        this.$bvModal.hide("modal-upload");

      } catch (e) {
        console.error("e");
        console.error(e);
        if (e.response.status === 422 && e.response.data.message) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-upload");
      }
    },
    async handleExport() {
      try {
        this.showLoading = true;

        await bookingApi.exportBookingPresetBranchDate(this.bookingPreset.id);

        this.$swal({
          title: "成功",
          text: "可至“我的主控台”查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } finally {
        this.showLoading = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.reservation-periods-container {
  .reservation-periods-header {
    font-weight: bold;
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid #dee2e6;
  }

  .reservation-period-row {
    padding: 8px 0;

    &:hover {
      background-color: #f8f9fa;
    }
  }
}

.menu-items > li {
  cursor: pointer;

  &.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }

  &.has-checkbox {
    &:after {
      content: "\f134";
      font-family: "Material Design Icons";
      font-size: 16px;
    }
  }

  &.has-checkbox.has-checkbox--checked {
    &:after {
      content: "\f133";
      color: green;
    }
  }
}

.custom-table-striped {

    background-color: rgba(0, 0, 0, 0.05);

}

.time-option-drag-handler {
  cursor: move;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}

.limit-setting-radio-group {
  .custom-control-input:checked:disabled ~ .custom-control-label::before {
    background-color: #2a7be4;
    border-color: #2a7be4;
    opacity: 1;
  }
}

.occupy-limit-tip-icon {
  cursor: pointer;
}
</style>
